
// src/config/instagram.ts
export const INSTAGRAM_CONFIG = {
  // URLs da API - usando variáveis de ambiente
  API_URLS: {
    PRODUCTION: import.meta.env.VITE_INSTAGRAM_API_URL_PROD || 'https://instagram-api-backend.onrender.com',
    DEVELOPMENT: import.meta.env.VITE_INSTAGRAM_API_URL || 'http://localhost:3001',
  },
  
  // Configurações de timing
  TIMING: {
    AUTO_REFRESH_INTERVAL: 5 * 60 * 1000, // 5 minutos
    API_TIMEOUT: 30000, // 30 segundos
    HEALTH_CHECK_TIMEOUT: 10000, // 10 segundos
    REFRESH_TIMEOUT: 45000, // 45 segundos para refresh manual
  },
  
  // URLs do Instagram
  INSTAGRAM: {
    PROFILE_URL: 'https://www.instagram.com/brenda.nutricionista/',
  },
  
  // Configurações de fallback
  FALLBACK: {
    IMAGE: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=400&h=400&fit=crop',
    POSTS: [
      {
        id: 'fallback_1',
        image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=400&fit=crop',
        caption: 'Workshop sobre alimentação saudável foi um sucesso! 🥗✨',
        date: '2 dias atrás',
        permalink: 'https://www.instagram.com/brenda.nutricionista/',
      },
      {
        id: 'fallback_2',
        image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop',
        caption: 'Palestra sobre hidratação no evento de bem-estar 💧',
        date: '5 dias atrás',
        permalink: 'https://www.instagram.com/brenda.nutricionista/',
      },
      {
        id: 'fallback_3',
        image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=400&h=400&fit=crop',
        caption: 'Encontro com pacientes para compartilhar receitas saudáveis 👩‍🍳',
        date: '1 semana atrás',
        permalink: 'https://www.instagram.com/brenda.nutricionista/',
      },
    ],
  },
  
  // Mensagens de erro padrão
  ERROR_MESSAGES: {
    TIMEOUT: 'Timeout: API demorou para responder (Render pode estar "dormindo")',
    CONNECTION: 'Erro de conexão com a API',
    NETWORK: 'Erro de rede - verifique sua conexão',
    INVALID_RESPONSE: 'Resposta inválida da API',
    NO_POSTS: 'Nenhum post encontrado',
    GENERIC: 'Erro ao carregar posts do Instagram',
    REFRESH_FAILED: 'Falha ao atualizar posts',
  },
} as const;

// Helper function para obter URL da API - usando variáveis de ambiente
export const getApiUrl = (): string => {
  return import.meta.env.PROD 
    ? INSTAGRAM_CONFIG.API_URLS.PRODUCTION
    : INSTAGRAM_CONFIG.API_URLS.DEVELOPMENT;
};

// Helper function para obter configuração baseada no ambiente
export const getEnvironmentConfig = () => {
  const isDev = import.meta.env.DEV;
  const isProd = import.meta.env.PROD;
  const mode = import.meta.env.MODE;
  
  return {
    isDev,
    isProd,
    mode,
    apiUrl: getApiUrl(),
    enableDebug: isDev,
    autoRefreshInterval: INSTAGRAM_CONFIG.TIMING.AUTO_REFRESH_INTERVAL,
    apiTimeout: INSTAGRAM_CONFIG.TIMING.API_TIMEOUT,
  };
};

// Helper para logs condicionais (apenas em dev)
export const debugLog = (...args: any[]) => {
  if (import.meta.env.DEV) {
    console.log('[Instagram Debug]', ...args);
  }
};

// Helper para detectar se está rodando no Lovable
export const isLovableEnvironment = () => {
  return import.meta.env.MODE === 'development' && 
         window.location.hostname.includes('lovable');
};
